export default __webpack_public_path__ + "static/media/PayID-Desktop.070f10e6.png";